export interface KeyStrategy {
  transformKey(key: string): string;
  matches(transformedKey: string): boolean;
}

// PrefixKeyStrategy adds a prefix to keys for namespacing - e.g you could have a prefix like `${userId}-${feature}`
export class PrefixKeyStrategy implements KeyStrategy {
  constructor(private prefix: string | null | undefined) {}

  transformKey(key: string): string {
    if (!this.prefix) {
      return key; // No prefix, return the key as is
    }
    return `${this.prefix}:${key}`;
  }

  matches(fullKey: string): boolean {
    if (!this.prefix) {
      return false; // No prefix, no keys match
    }
    return fullKey.startsWith(`${this.prefix}:`);
  }
}
